module.exports = __webpack_public_path__ + "img/learning-center.49837716.svg";